(function () {
  const API = "https://vivishop.area.lv/shopify-omniva-api.php";
  const ATTR_NAME = "Omniva pakomāts";
  const ATTR_ZIP = "Omniva ZIP";
  const ATTR_MODE = "Piegādes veids";
  const WAREHOUSE_LABEL = "SAŅEMT NOLIKTAVĀ (Brīvības Gatve 403, Rīga)";
  const ROOT_CLASS = "vivi-omniva-locker";

  const css = `
.${ROOT_CLASS}{margin:1.2rem 0 1.6rem;padding:1rem 1.1rem;border:1px solid rgba(18,18,18,.12);border-radius:10px;background:#fff;position:relative}
.${ROOT_CLASS} h3{margin:0 0 .35rem;font-size:1rem;letter-spacing:.02em}
.${ROOT_CLASS} p{margin:0 0 .75rem;color:rgba(18,18,18,.65);font-size:.85rem;line-height:1.35}
.${ROOT_CLASS} .vivi-omniva-modes{display:flex;flex-direction:column;gap:.45rem;margin:0 0 .85rem}
.${ROOT_CLASS} .vivi-omniva-modes label{display:flex;gap:.55rem;align-items:flex-start;font-size:.9rem;cursor:pointer;line-height:1.35}
.${ROOT_CLASS} .vivi-omniva-modes input{margin-top:.2rem}
.${ROOT_CLASS} .vivi-omniva-row{position:relative}
.${ROOT_CLASS} input[type=search]{width:100%;padding:.7rem .85rem;border:1px solid rgba(18,18,18,.18);border-radius:8px;font:inherit}
.${ROOT_CLASS} ul{list-style:none;margin:.35rem 0 0;padding:0;position:absolute;left:0;right:0;z-index:40;max-height:240px;overflow:auto;background:#fff;border:1px solid rgba(18,18,18,.14);border-radius:8px;box-shadow:0 10px 28px rgba(18,18,18,.1)}
.${ROOT_CLASS} ul[hidden]{display:none!important}
.${ROOT_CLASS} button.vivi-omniva-item{display:block;width:100%;text-align:left;border:0;background:transparent;padding:.65rem .8rem;font:inherit;cursor:pointer}
.${ROOT_CLASS} button.vivi-omniva-item:hover,.${ROOT_CLASS} button.vivi-omniva-item.is-active{background:rgba(18,18,18,.05)}
.${ROOT_CLASS} button.vivi-omniva-item strong{display:block;font-size:.92rem}
.${ROOT_CLASS} button.vivi-omniva-item span{display:block;font-size:.78rem;color:rgba(18,18,18,.55)}
.${ROOT_CLASS} .vivi-omniva-selected{margin-top:.55rem;font-size:.85rem}
.${ROOT_CLASS} .vivi-omniva-selected.is-empty{color:#b42318}
.${ROOT_CLASS} .vivi-omniva-selected.is-ok{color:#067647}
.${ROOT_CLASS} .vivi-omniva-hint{margin:.35rem 0 0;font-size:.8rem;color:rgba(18,18,18,.55)}
`;

  function ensureCss() {
    if (document.getElementById("vivi-omniva-locker-css")) return;
    const style = document.createElement("style");
    style.id = "vivi-omniva-locker-css";
    style.textContent = css;
    document.head.appendChild(style);
  }

  function isWarehouse(name) {
    const n = (name || "").toLowerCase();
    return n.includes("noliktav") || n.includes("saņemt nolikt");
  }

  function cartAttrs() {
    return fetch("/cart.js", { credentials: "same-origin" })
      .then((r) => (r.ok ? r.json() : null))
      .then((cart) => (cart && cart.attributes) || {});
  }

  function saveAttrs(mode, name, zip) {
    const body = {
      attributes: {
        [ATTR_MODE]: mode || "",
        [ATTR_NAME]: name || "",
        [ATTR_ZIP]: zip || "",
      },
    };
    return fetch("/cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body),
    }).then((r) => (r.ok ? r.json() : null));
  }

  function mount(host) {
    if (!host || host.querySelector("." + ROOT_CLASS)) return;
    ensureCss();
    const box = document.createElement("div");
    box.className = ROOT_CLASS;
    box.innerHTML =
      "<h3>Piegāde</h3>" +
      "<p>Pirms apmaksas izvēlies <strong>Omniva pakomātu</strong> vai <strong>saņemšanu noliktavā</strong>. Checkoutā izvēlies to pašu piegādes veidu.</p>" +
      '<div class="vivi-omniva-modes">' +
      '<label><input type="radio" name="vivi-delivery" value="omniva" data-mode> <span><strong>Omniva paku skapis</strong> — jāizvēlas konkrēts pakomāts</span></label>' +
      '<label><input type="radio" name="vivi-delivery" value="warehouse" data-mode> <span><strong>Saņemt noliktavā</strong> — Brīvības Gatve 403, Rīga</span></label>' +
      "</div>" +
      '<div class="vivi-omniva-row" data-picker hidden>' +
      '<input type="search" autocomplete="off" placeholder="Sāc rakstīt — pilsēta, iela, Maxima…" aria-label="Omniva pakomāts">' +
      '<ul hidden></ul></div>' +
      '<div class="vivi-omniva-selected is-empty" data-selected>Izvēlies piegādes veidu</div>' +
      '<p class="vivi-omniva-hint" data-hint hidden>Checkoutā izvēlies «Omniva paku skapis».</p>';
    host.prepend(box);

    const modeInputs = box.querySelectorAll("[data-mode]");
    const picker = box.querySelector("[data-picker]");
    const input = box.querySelector("input[type=search]");
    const list = box.querySelector("ul");
    const selected = box.querySelector("[data-selected]");
    const hint = box.querySelector("[data-hint]");
    let items = [];
    let active = -1;
    let timer = 0;
    let mode = "";
    let currentName = "";
    let currentZip = "";

    const getMode = () => {
      for (const el of modeInputs) {
        if (el.checked) return el.value;
      }
      return "";
    };

    const setModeUi = (next, persist) => {
      mode = next || "";
      modeInputs.forEach((el) => {
        el.checked = el.value === mode;
      });
      if (picker) picker.hidden = mode !== "omniva";
      if (hint) {
        hint.hidden = mode !== "omniva";
        hint.textContent =
          mode === "omniva"
            ? "Checkoutā izvēlies «Omniva paku skapis»."
            : mode === "warehouse"
              ? "Checkoutā izvēlies «SAŅEMT NOLIKTAVĀ»."
              : "";
        if (mode === "warehouse") hint.hidden = false;
      }
      if (mode === "warehouse") {
        currentName = WAREHOUSE_LABEL;
        currentZip = "";
        selected.className = "vivi-omniva-selected is-ok";
        selected.textContent = WAREHOUSE_LABEL;
        if (input) input.value = "";
        hide();
        if (persist) saveAttrs("noliktava", WAREHOUSE_LABEL, "").catch(() => {});
        return;
      }
      if (mode === "omniva") {
        if (isWarehouse(currentName)) {
          currentName = "";
          currentZip = "";
        }
        paintSelected();
        if (persist) saveAttrs("omniva", currentName, currentZip).catch(() => {});
        return;
      }
      currentName = "";
      currentZip = "";
      selected.className = "vivi-omniva-selected is-empty";
      selected.textContent = "Izvēlies piegādes veidu";
      if (persist) saveAttrs("", "", "").catch(() => {});
    };

    const paintSelected = () => {
      if (mode === "warehouse") {
        selected.className = "vivi-omniva-selected is-ok";
        selected.textContent = WAREHOUSE_LABEL;
        return;
      }
      if (mode === "omniva" && currentName && !isWarehouse(currentName)) {
        selected.className = "vivi-omniva-selected is-ok";
        selected.textContent = currentName + (currentZip ? " · " + currentZip : "");
        if (input) input.value = currentName;
        return;
      }
      selected.className = "vivi-omniva-selected is-empty";
      selected.textContent =
        mode === "omniva" ? "Pakomāts nav izvēlēts" : "Izvēlies piegādes veidu";
    };

    const setLocker = (name, zip, persist) => {
      currentName = name || "";
      currentZip = zip || "";
      paintSelected();
      if (persist) {
        saveAttrs("omniva", currentName, currentZip).catch(() => {});
      }
    };

    const hide = () => {
      list.hidden = true;
      list.innerHTML = "";
      active = -1;
    };

    const render = () => {
      list.innerHTML = "";
      if (!items.length) {
        hide();
        return;
      }
      items.forEach((item, index) => {
        const li = document.createElement("li");
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "vivi-omniva-item" + (index === active ? " is-active" : "");
        btn.innerHTML = "<strong></strong>" + (item.zip ? "<span></span>" : "");
        btn.querySelector("strong").textContent = item.name || "";
        const span = btn.querySelector("span");
        if (span) span.textContent = item.zip || "";
        btn.addEventListener("mousedown", (e) => {
          e.preventDefault();
          setLocker(item.name || "", item.zip || "", true);
          hide();
        });
        li.appendChild(btn);
        list.appendChild(li);
      });
      list.hidden = false;
    };

    const lookup = () => {
      const q = input.value.trim();
      if (q.length < 2) {
        hide();
        return;
      }
      fetch(API + "?q=" + encodeURIComponent(q), { credentials: "omit" })
        .then((r) => (r.ok ? r.json() : null))
        .then((data) => {
          if (input.value.trim() !== q) return;
          items = data && Array.isArray(data.items) ? data.items : [];
          active = items.length ? 0 : -1;
          render();
        })
        .catch(() => {});
    };

    const isReady = () => {
      if (mode === "warehouse") return true;
      if (mode === "omniva") {
        const typed = input ? input.value.trim() : "";
        return !!(currentName && !isWarehouse(currentName) && (!typed || typed === currentName));
      }
      return false;
    };

    const blockMsg = () => {
      if (!mode) return "Izvēlies piegādi: Omniva pakomāts vai saņemt noliktavā.";
      if (mode === "omniva") {
        const typed = input ? input.value.trim() : "";
        if (currentName && typed && typed !== currentName) {
          return "Izvēlies pakomātu no saraksta (nevis brīvu tekstu).";
        }
        return "Izvēlies Omniva pakomātu no saraksta pirms apmaksas.";
      }
      return "Izvēlies piegādes veidu.";
    };

    input.addEventListener("input", () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(lookup, 140);
    });
    input.addEventListener("keydown", (e) => {
      if (list.hidden || !items.length) return;
      if (e.key === "ArrowDown") {
        e.preventDefault();
        active = (active + 1) % items.length;
        render();
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        active = (active - 1 + items.length) % items.length;
        render();
      } else if (e.key === "Enter" && active >= 0 && items[active]) {
        e.preventDefault();
        setLocker(items[active].name || "", items[active].zip || "", true);
        hide();
      } else if (e.key === "Escape") {
        hide();
      }
    });
    input.addEventListener("blur", () => window.setTimeout(hide, 160));
    modeInputs.forEach((el) => {
      el.addEventListener("change", () => setModeUi(getMode(), true));
    });

    cartAttrs().then((attrs) => {
      const name = (attrs[ATTR_NAME] || attrs["omniva_terminal"] || "").trim();
      const zip = (attrs[ATTR_ZIP] || attrs["omniva_zip"] || "").trim();
      const savedMode = (attrs[ATTR_MODE] || "").trim().toLowerCase();
      if (savedMode === "noliktava" || isWarehouse(name)) {
        setModeUi("warehouse", false);
      } else if (savedMode === "omniva" || name) {
        currentName = isWarehouse(name) ? "" : name;
        currentZip = zip;
        setModeUi("omniva", false);
        paintSelected();
      } else {
        setModeUi("", false);
      }
    });

    document.addEventListener(
      "click",
      (e) => {
        const btn =
          e.target && e.target.closest
            ? e.target.closest('[name="checkout"], #checkout, button[name="checkout"], a[href="/checkout"]')
            : null;
        if (!btn || !box.isConnected) return;
        if (isReady()) return;
        e.preventDefault();
        e.stopPropagation();
        selected.className = "vivi-omniva-selected is-empty";
        selected.textContent = blockMsg();
        if (mode === "omniva") {
          input.focus();
          if (input.value.trim().length >= 2) lookup();
        }
      },
      true
    );
  }

  function targets() {
    const nodes = [];
    const footer = document.querySelector("#main-cart-footer .cart__blocks, #main-cart-footer .cart__footer");
    if (footer) nodes.push(footer);
    const drawer = document.querySelector("#CartDrawer .cart-drawer__footer, #CartDrawer .drawer__footer, cart-drawer .cart-drawer__footer");
    if (drawer) nodes.push(drawer);
    document.querySelectorAll('form[action="/cart"], form#cart').forEach((form) => {
      const parent = form.querySelector(".cart__footer, .cart__blocks") || form;
      nodes.push(parent);
    });
    return nodes;
  }

  function boot() {
    targets().forEach(mount);
  }

  boot();
  document.addEventListener("shopify:section:load", boot);
  const obs = new MutationObserver(() => boot());
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();